/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {Tag} from 'folder-items/FileConstants';
import {BORDER_RADIUS_DEFAULT} from 'styles/StyleConstants';
import * as keyboard from 'util/Keyboard';

interface Props {
  autoFocus: boolean;
  defaultValue?: Tag;
  onChange: (...args: Array<any>) => any;
  onKeyDown?: (...args: Array<any>) => any;
  placeholder?: string;
}

class LongTextValueEditor extends React.Component<Props> {
  _handleKeyDown = (e: any): void => {
    // forward to onKeyDown if available and it's not a shift enter (preserve default new line behavior)
    if (this.props.onKeyDown && !(e.shiftKey && keyboard.isEnterKey(e))) {
      this.props.onKeyDown(e);
    }
  };

  _handleOnChange = (e: any): void => {
    this.props.onChange({value: e.target.value});
  };

  render(): JSX.Element {
    const value = this.props.defaultValue ? this.props.defaultValue.value || '' : '';
    return (
      <textarea
        autoFocus={this.props.autoFocus}
        className={classNames('metadata-tagValueTextArea', css(styles.textarea))}
        name="long_text_value"
        onFocus={(e) => {
          const input = e.target;
          input.setSelectionRange(0, input.value.length);
        }}
        onKeyDown={this._handleKeyDown}
        onChange={this._handleOnChange}
        placeholder={this.props.placeholder}
        rows={3}
        value={value}
      />
    );
  }
}

export default LongTextValueEditor;

const styles = StyleSheet.create({
  textarea: {
    borderRadius: BORDER_RADIUS_DEFAULT,
  },
});
